import { Fragment } from 'react';
import { createFileRoute, useParams, useRouter } from '@tanstack/react-router';
import BackTo, { BACKTO_HEIGHT } from '../../components/BackTo';
import JumpDetails from '@/components/JumpDetails';
import JumpTeam from '@/components/JumpTeam';
import Authorized from '@/components/Authorized';

const route = '/submission/$submissionId';

export const Route = createFileRoute(route)({
  component: SubmissionDetailPage,
})

function SubmissionDetailPage() {
    const { submissionId } = useParams({ from: route });
    const router = useRouter();
    const backRouteFunc = () => router.history.back();
    const scrollViewStyles = {
      height: `calc(100% - ${BACKTO_HEIGHT})`
    }

    return (
      <Fragment>
        <Authorized>
            <BackTo route={backRouteFunc} label="Back to leaderboard" />
            <div className="scrolling-container" style={scrollViewStyles}>
              <div className="outer-container">
                  <JumpDetails jumpId={submissionId} />
                  <JumpTeam jumpId={submissionId} />
              </div>
            </div>
        </Authorized>
      </Fragment>
    )
}
